import {PureComponent} from 'react';
import {Switch, Redirect, Route} from 'react-router-dom';

import {ROUTE_PATH} from 'constants/routes';
import {NativeRoute} from 'utils/routes';

import {
    ClientConferenceAndroidSDK, ClientConferenceAndroidSDKOld, ClientConferenceIosSDK, ClientConferenceIosSDKOld
} from './ClientConferenceSDK';
import {ClientConferenceWeb} from './ClientConferenceWeb';

export class ClientConference extends PureComponent {
    render() {
        return (
            <Switch>
                <NativeRoute path={ROUTE_PATH.CLIENT.CONFERENCE.ANDROID_SDK_OLD} component={ClientConferenceAndroidSDKOld} />
                <NativeRoute path={ROUTE_PATH.CLIENT.CONFERENCE.ANDROID_SDK} component={ClientConferenceAndroidSDK} />
                <NativeRoute path={ROUTE_PATH.CLIENT.CONFERENCE.IOS_SDK_OLD} component={ClientConferenceIosSDKOld} />
                <NativeRoute path={ROUTE_PATH.CLIENT.CONFERENCE.IOS_SDK} component={ClientConferenceIosSDK} />
                <Route
                    path={ROUTE_PATH.CLIENT.CONFERENCE.WEB_CONVERSATION_ONLY}
                    render={(props: any) => <ClientConferenceWeb {...props} conversationOnly />}
                />
                <Route path={ROUTE_PATH.CLIENT.CONFERENCE.WEB} component={ClientConferenceWeb} />

                {/* TODO: Temporary while Bancomer will not change url in SDK */}
                <Redirect to={ROUTE_PATH.CLIENT.CONFERENCE.ANDROID_SDK_OLD} />
            </Switch>
        );
    }
}
